import { ArrowUp } from "lucide-react";
import { Link } from "react-router-dom";
import { useSectionNav } from "../lib/lenisStore";

const SOCIALS = [
  { label: "Instagram", handle: "@elegance_noire" },
  { label: "Pinterest", handle: "elegancenoire" },
  { label: "Vogue Weddings", handle: "Directory Listing" },
];

export default function Footer() {
  const scrollToSection = useSectionNav();
  return (
    <footer data-testid="footer-section" className="relative overflow-hidden border-t border-white/10 bg-obsidian">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <div>
            <p className="font-serif text-2xl text-ivory">
              Élégance Noire <span className="text-gold">&</span> Lumière
            </p>
            <p className="mt-3 max-w-sm text-sm font-light text-stone-400 leading-relaxed">
              Fine art cinematic & haute-couture wedding photography, crafted between Paris and
              Lake Como.
            </p>
            <div className="mt-6 flex flex-wrap gap-x-8 gap-y-2">
              {SOCIALS.map((s) => (
                <span key={s.label} data-testid={`footer-social-${s.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-[11px] font-mono tracking-[0.2em] uppercase text-stone-400">
                  {s.label} <span className="text-champagne/70">{s.handle}</span>
                </span>
              ))}
            </div>
          </div>
          <button
            data-testid="footer-back-top"
            onClick={() => scrollToSection("hero")}
            className="group inline-flex items-center gap-3 border border-white/15 px-6 py-3 text-[11px] font-mono tracking-[0.2em] uppercase text-stone-300 hover:border-champagne hover:text-champagne transition-colors duration-300 self-start md:self-auto"
          >
            Back to Top
            <ArrowUp size={14} className="transition-transform duration-300 group-hover:-translate-y-1" />
          </button>
        </div>

        <div className="mt-16 select-none" aria-hidden="true">
          <p className="font-serif text-[16vw] leading-[0.85] text-white/[0.04] text-center tracking-tight">
            ÉLÉGANCE
          </p>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-white/10 pt-6">
          <p className="text-[10px] font-mono tracking-[0.2em] uppercase text-stone-600">
            © 2026 Élégance Noire & Lumière. All frames reserved.
          </p>
          <p className="text-[10px] font-mono tracking-[0.2em] uppercase text-stone-600">
            Paris · Lake Como · Kyoto · Highlands ·{" "}
            <Link to="/journal" data-testid="footer-journal-link" className="hover:text-champagne transition-colors">Journal</Link> ·{" "}
            <Link to="/admin" data-testid="footer-studio-login" className="hover:text-champagne transition-colors">Studio Login</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
